import styled from 'styled-components';
import { theme } from '../theme';

function getButtonTheme(props) {
  return ButtonTheme[props.variation || 'secondary'];
}

export const ButtonElement = styled.button`
  box-shadow: none;
  display: inline-block;
  font-size: 14px;
  padding: 5px 20px;
  line-height: 1.42857143;
  text-align: center;
  height: 40px;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
  background-image: none;
  text-decoration: none;
  margin: 0;
  font-weight: 600;
  color: ${props => getButtonTheme(props).color};
  background-color: ${props => getButtonTheme(props).bgColor};
  border: ${props => '1px solid ' + getButtonTheme(props).borderColor};
  svg path {
    fill: ${props => getButtonTheme(props).color};
  }
  &&:hover {
    border: ${props => '1px solid ' + getButtonTheme(props).hoverBorderColor};
    background-color: ${props => getButtonTheme(props).hoverBgColor};
  }
  &&:active {
    color: ${props => getButtonTheme(props).activeColor};
    background-color: ${props => getButtonTheme(props).activeBgColor};
    transition: none;
    svg path {
      fill: ${props => getButtonTheme(props).activeColor};
    }
  }
  &&:disabled {
    color: ${props => getButtonTheme(props).disabledColor};
    border-color: ${props => getButtonTheme(props).disabledBgColor};
    background-color: ${props => getButtonTheme(props).disabledBgColor};
    cursor: not-allowed;
    svg path {
      fill: ${props => getButtonTheme(props).disabledColor};
    }
  }
` as any;

export const ButtonTheme = {
  primary: {
    color: theme.vars.newColor.white,
    bgColor: theme.vars.newColor.blue2,
    borderColor: theme.vars.newColor.blue2,
    hoverBgColor: theme.vars.newColor.blue2,
    hoverBorderColor: theme.vars.newColor.blue1,
    activeBgColor: theme.vars.newColor.blue1,
    disabledColor: theme.vars.newColor.darkGS3,
    disabledBgColor: theme.vars.newColor.lightGS2,
  },
  secondary: {
    color: theme.vars.newColor.darkGS2,
    bgColor: theme.vars.newColor.white,
    borderColor: theme.vars.newColor.darkGS2,
    hoverBgColor: theme.vars.newColor.lightGS2,
    hoverBorderColor: theme.vars.newColor.lightGS1,
    activeBgColor: theme.vars.newColor.blue1,
    activeColor: theme.vars.newColor.white,
    disabledColor: theme.vars.newColor.darkGS3,
    disabledBgColor: theme.vars.newColor.lightGS2,
  },
  clean: {
    color: theme.vars.newColor.darkGS2,
    bgColor: theme.vars.newColor.white,
    borderColor: theme.vars.newColor.white,
    hoverBgColor: theme.vars.newColor.lightGS2,
    hoverBorderColor: theme.vars.newColor.lightGS1,
    activeBgColor: theme.vars.newColor.blue1,
    activeColor: theme.vars.newColor.white,
    disabledColor: theme.vars.newColor.darkGS3,
    disabledBgColor: theme.vars.newColor.lightGS2,
  },
};
